// mds-dojo — dojo/store/util/QueryResults — FAITHFUL port of
// references/dojo/store/util/QueryResults.js. Wraps a query result (array or
// promise) with iterative forEach/filter/map plus a `total`. Used by
// dijit/form/_FormSelectWidget's dojo.data back-compat query() shim.
// ADAPTATION: `../../_base/{array,lang}` + `../../when` import paths only.
import array from '../../_base/array';
import lang from '../../_base/lang';
import when from '../../when';

var QueryResults: any = function (results: any) {
	// summary:
	//		A function that wraps the results of a store query with additional
	//		methods.
	// description:
	//		QueryResults is a basic wrapper that allows for array-like iteration
	//		over any kind of returned data from a query.

	if (!results) {
		return results;
	}

	var isPromise = !!results.then;
	// if it is a promise it may be frozen
	if (isPromise) {
		results = lang.delegate(results);
	}
	function addIterativeMethod(method: string) {
		// Always add the iterative methods so a QueryResults is
		// returned whether the environment is ES3 or ES5
		results[method] = function () {
			var args = arguments;
			var result = when(results, function (results: any) {
				Array.prototype.unshift.call(args, results);
				return QueryResults((array as any)[method].apply(array, args));
			});
			// forEach should only return the result of when()
			// when we're wrapping a promise
			if (method !== "forEach" || isPromise) {
				return result;
			}
		};
	}

	addIterativeMethod("forEach");
	addIterativeMethod("filter");
	addIterativeMethod("map");
	if (results.total == null) {
		results.total = when(results, function (results: any) {
			return results.length;
		});
	}
	return results; // Object
};

lang.setObject("dojo.store.util.QueryResults", QueryResults);

export default QueryResults;
